// extracted by mini-css-extract-plugin
export var root = "L_wH";
export var wrapper = "L_wJ";
export var image = "L_wK g_bD g_bG g_b2";
export var crop = "L_wL";
export var round = "L_wM";
export var fixedHeight = "L_wN";